import React from 'react';
import { GraduationCap, ExternalLink } from 'lucide-react';
import type { SearchPubmedWidgetData } from '../../../types/agentWidgets';

interface Props {
  data: SearchPubmedWidgetData;
}

export const SearchPubmedWidget: React.FC<Props> = ({ data }) => {
  return (
    <div className="mt-1.5 space-y-1.5 text-[11px]">
      <div className="flex items-center gap-2 bg-orange-50/70 dark:bg-orange-900/10 rounded px-2 py-1.5">
        <GraduationCap className="h-3 w-3 text-orange-500 dark:text-orange-400 flex-shrink-0" />
        <span className="font-medium text-orange-700 dark:text-orange-300">
          {data.articleCount} article{data.articleCount !== 1 ? 's' : ''} found
        </span>
        <a
          href={data.searchUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="ml-auto flex items-center gap-1 text-[10px] text-orange-600 dark:text-orange-400 hover:underline font-medium"
        >
          View on PubMed
          <ExternalLink className="h-2.5 w-2.5" />
        </a>
      </div>
      {data.pmids.length > 0 && (
        <div className="flex flex-wrap gap-1 ml-5">
          {data.pmids.map((pmid) => (
            <a
              key={pmid}
              href={`https://pubmed.ncbi.nlm.nih.gov/${pmid}/`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[10px] font-mono px-1.5 py-0.5 rounded bg-orange-100/60 dark:bg-orange-900/20 text-orange-600 dark:text-orange-400 hover:bg-orange-200/60 dark:hover:bg-orange-900/30 transition-colors"
            >
              {pmid}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};
